module.exports = __webpack_public_path__ + "images/directory/featured-hero/slack.ae267bad61ecbcf5ed15.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/slack.jpg
// module id = JClc
// module chunks = 2